import { Link } from "react-router-dom";

export function Logo() {
  return (
    <Link to="/" className="group flex items-center gap-2">
      <span className="grid h-8 w-8 place-items-center rounded-[0.55rem] border border-accent-300/30 bg-accent-500/15 font-mono text-[10px] font-medium uppercase tracking-tight text-accent-100 shadow-[inset_0_1px_0_oklch(96%_0.035_84_/_0.16)] transition-transform duration-300 group-hover:-rotate-3">
        bg
      </span>
      <span className="text-lg font-extrabold tracking-tight">
        hero<span className="text-accent-300">bg</span>
      </span>
    </Link>
  );
}
